import React, { useEffect, useState } from 'react';
import styles from './ShareCode.module.css';
import axios from 'axios';
import { basePath } from '../../index';
import MaskedInput from 'react-text-mask';

const ShareCode = ({ showModal, closeModal, EnquiryNo, LotNo, MobileNo }) => {
    const [mobileNumber, setMobileNumber] = useState('');
    const [whatsappNumber, setWhatsappNumber] = useState('');
    const [email, setEmail] = useState('');
    const [copySuccess, setCopySuccess] = useState('Copy');
    const [copyURL, setCopyURL] = useState(null);
    const [data, setData] = useState(null);
    const [shareId, setShareId] = useState('');
    const [error, setError] = useState({});

    const handleCopy = () => {
        navigator.clipboard.writeText(copyURL);
        setCopySuccess('Copied!');
        setTimeout(() => setCopySuccess('Copy'), 2000);
    };


    useEffect(() => {
        postData("copy");
        setMobileNumber(MobileNo);
        setWhatsappNumber(MobileNo)
    }, []);

    const validateEmail = (email) => {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const validateInput = (param) => {
        let error = {};
        let goto = true;
        if (param === 'mob'  || param ==='wt') {
            if (!mobileNumber) {
                goto = false;
                error[param === 'mob' ? 'mobileNumber' : 'whatsappNumber'] = `Please enter ${param ==='mob'? 'mobile' :'whatsapp'} number`;
            } else if ((param==='mob' ? mobileNumber:whatsappNumber)?.length  < 10) {
                goto = false;
                error[param === 'mob' ? 'mobileNumber' : 'whatsappNumber'] = `Entered ${param === 'mob' ? 'mobile' : 'whatsapp'} number should be of 10 digits`
            }
            else if ((param === 'mob' ? mobileNumber : whatsappNumber) === "9999999999" || (param === 'mob' ? mobileNumber : whatsappNumber) === "8888888888" || (param === 'mob' ? mobileNumber : whatsappNumber) === "7777777777" || (param === 'mob' ? mobileNumber : whatsappNumber) === "6666666666") {
                goto = false;
                error[param === 'mob' ? 'mobileNumber' : 'whatsappNumber'] = `Please enter valid ${param === 'mob' ? 'mobile' : 'whatsapp'} number`
            }
        } else if (param === 'email') {

            if (!email) {
                goto = false;
                error['email'] = "Please enter email";
            } else if (!validateEmail(email)) {
                goto = false;
                error['email'] = 'Please enter valid email'
            }
        } 

        setError(error);

        return goto;


    }

    const postData = async (param) => {

        if (validateInput(param)) {

        const requestBody = {
            EnquiryNo,
            LotNo,
            ShareMode: param === "mob" ? 0 : param === "email" ? 1 : param === "copy" ? 4 : 2,
            ShareTo: param === "mob" ? mobileNumber : param === "email" ? email : param === "copy" ? "copy@gmail.com" : "",
            UserID: 0,
            TransKey: "",
            HideInsurerIDs: null,
            OtherData: ""
        };

        try {

            const response = await axios.post(`central/centralcall/callreqwithheader`, { URL: "ShareQuote", Req: requestBody })
            setData(response.data);
            setShareId(response.data.Data.Token.split('shareid')[1])
            if (param !== "copy")
                alert(response.data.Data.Message);
            else setCopyURL(response.data.Data.Token);
        } catch (error) {
            setError(error.message);
            }

        }
    };

    const redirectToWhatsapp = (param) => {
        if (validateInput(param)) {
            const link = `https://wa.me/${whatsappNumber}?text=${window.location.origin +"/investment/investmentQuotes" + "?shareid" + shareId}`;
            window.open(link, '_blank');
        }
    }
  
    


    return (
        <div className={styles.modalBackdrop}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3>Share Quote</h3>
                    <button className={styles.closeButton} onClick={closeModal}>&times;</button>
                </div>
                <div className={styles.modalBody}>
                    <div className={styles.inputGroup}>
                        <div className={styles.label}>SMS</div>
                        <div className={styles.share_inp}>
                            <MaskedInput
                                className="inputText "
                                mask={[
                                    /[6-9]/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                ]}
                                guide={false}
                                showMask={false}
                                placeholder="Mobile Number"
                                value={mobileNumber}
                                onChange={(e) => setMobileNumber(e.target.value)}
                            />
                            <button className={styles.shareButton} onClick={() => postData("mob")}>Share</button>
                        </div>
                    </div>
                    <span className={styles.shareQuoteErrorText}>{error["mobileNumber"]}</span>

                    <div className={styles.inputGroup}>
                        <div className={styles.label}>WhatsApp</div>
                        <div className={styles.share_inp}>
                            <MaskedInput
                                className="inputText "
                                mask={[
                                    /[6-9]/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                ]}
                                guide={false}
                                showMask={false}
                                placeholder="WhatsApp Number"
                                value={whatsappNumber}
                                onChange={(e) => setWhatsappNumber(e.target.value)}
                            />
                            <button className={styles.shareButton} onClick={() => redirectToWhatsapp("wt")}>Share</button>
                        </div>
                    </div>
                    <span className={styles.shareQuoteErrorText}>{error["whatsappNumber"]}</span>
                    <div className={styles.inputGroup}>
                        <div className={styles.label}>Email</div>
                        <div className={styles.share_inp}>
                            <input
                                type="email"
                                placeholder="Enter Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <button className={styles.shareButton} onClick={() => postData("email")}>Share</button>
                        </div>
                    </div>
                        <span className={styles.shareQuoteErrorText}>{error["email"]}</span>
                    <div className={styles.inputGroup}>
                        <div className={styles.label}>Link</div>
                        <div className={styles.share_inp}>
                            <input
                                type="text"
                                value={copyURL}
                                readOnly
                            />
                            <button className={styles.shareButton} disabled={!copyURL} onClick={handleCopy}>{copySuccess}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareCode;
